import I18n from 'i18n-js';
import React from 'react';
import errorImageSrc from '../../../images/top-level/500.svg';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { IUser } from '@reverbdotcom/commons';
import { DEPLOY_ENV, ENABLE_DATADOG_ERROR_TRACKING } from '@reverbdotcom/env';

export default function ErrorDisplay() {
  const user = useUser();

  const isDatadogSearchDisplayed = shouldDisplayDatadogSearch({ currentUser: user, deployEnv: DEPLOY_ENV, isDatadogErrorTrackingEnabled: ENABLE_DATADOG_ERROR_TRACKING });

  return (
    <div className="error scaling-mtb-10 align-center">
      <img src={errorImageSrc} alt={I18n.t('discovery.errorAltText')} />
      <div className="mb-2">
        <h3 className="heading-3 scaling-mb-1">
          {I18n.t('discovery.errorDisplay.message')}
        </h3>
        <h3 className="heading-3">
          {I18n.t('discovery.errorDisplay.looking')}
        </h3>
      </div>
      <a href="/" className="button button--primary mr-1 mobile-mb-1">
        {I18n.t('discovery.errorDisplay.homepage')}
      </a>
      <a href="/page/contact" className="button">
        {I18n.t('discovery.errorDisplay.contact')}
      </a>
      {
        isDatadogSearchDisplayed &&
          <div className="mt-4">
            <a href={datadogErrorSearchUrl(user.requestId)} className="button-as-link color-red ph ph-l ph-search">
              Datadog Error Search
            </a>
          </div>
      }
      <div className="mt-6 d-flex fx-justify-center">
        <span className="pr-1">
          Request ID:
        </span>
        <pre>
          <code className="code-snippet">
            {user.requestId}
          </code>
        </pre>
      </div>
    </div>
  );
}

function datadogErrorSearchUrl(requestId: string) {
  const datadogQuery = `@usr.request_id:${requestId}`;

  return `https://app.datadoghq.com/error-tracking?query=${encodeURIComponent(datadogQuery)}`;
}

type ErrorDisplayPolicyArgs = {
  currentUser: Partial<IUser>;
  isDatadogErrorTrackingEnabled: boolean;
  deployEnv: string;
};

export function shouldDisplayDatadogSearch({ currentUser, isDatadogErrorTrackingEnabled, deployEnv }: ErrorDisplayPolicyArgs) {
  if (!isDatadogErrorTrackingEnabled) { return false; }

  // In non-prod, always show error search links
  if (deployEnv !== 'production') { return true; }

  // In production, show error search links to admins
  return currentUser.isAdmin;
}
